import {Attribute} from '../../components/ObjectAttribute';
import {Json} from '../../components/JsonObjectCard';
import searchPicksRequest from "./requests/searchPicksRequest";
import getPickRequest from "./requests/getPickRequest";
import startPickRequest from "./requests/startPickRequest";
import holdPickItemRequest from "./requests/holdPickItemRequest";
import {RequestDefinitionData} from "../../components/RequestDefinition";

const pickEndpoints: RequestDefinitionData[] = [
    searchPicksRequest,
    getPickRequest,
    startPickRequest,
    holdPickItemRequest,
];

export const pickHeader = {
    title: 'Picks',
    description: 'This is an object representing a Fishbowl pick.',
    linkName: 'Pick',
    link: 'https://help.fishbowlinventory.com/advanced/s/article/Picking',
    endpoints: pickEndpoints,
};

export const jsonObject: Json = {
    title: 'THE PICK OBJECT',
    json: {
        'id': 129,
        'number': 'S10074',
        'status': 'Finished',
        'type': 'Pick',
        'priority': '3-Normal',
        'locationGroup': {
            'id': 5,
            'name': 'SLC'
        },
        'username': 'admin',
        'dateCreated': '2026-04-03T04:19:58.933+00:00',
        'dateScheduled': '2026-01-07T13:54:21.000+00:00',
        'dateStarted': '2026-04-03T04:37:56.242+00:00',
        'dateFinished': '2026-04-03T04:37:56.242+00:00',
        'dateLastModified': '2026-04-03T04:37:56.445+00:00',
        'toBePrinted': false,
        'pickItems': [
            {
                'id': 548,
                'part': {
                    'id': 44,
                    'name': 'iTrack',
                    'description': 'Tracking Edge 705'
                },
                'status': 'Finished',
                'type': 'Normal',
                'quantity': '1',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'slotNum': 1,
                'order': {
                    'id': 71,
                    'number': '10074',
                    'type': 'SO',
                    'itemId': 157
                },
                'note': '',
                'overPicked': false,
                'finishable': false,
                'destinationTag': {
                    'location': {
                        'id': 27,
                        'name': 'Shipping'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                },
                'tracking': {
                    'trackingItems': [
                        {
                            'partTracking': {
                                'id': 4,
                                'name': 'Serial Number',
                                'description': ''
                            },
                            'serialNumbers': [
                                {
                                    'numbers': [
                                        {
                                            'partTracking': {
                                                'id': 4,
                                                'name': 'Serial Number',
                                                'description': ''
                                            },
                                            'value': 'ITRACK-35B675'
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            },
            {
                'id': 547,
                'part': {
                    'id': 79,
                    'name': 'B203',
                    'description': 'Basic Brake Cables'
                },
                'status': 'Finished',
                'type': 'Normal',
                'quantity': '8',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'slotNum': 1,
                'order': {
                    'id': 71,
                    'number': '10074',
                    'type': 'SO',
                    'itemId': 156
                },
                'note': '',
                'overPicked': false,
                'finishable': false,
                'currentTag': {
                    'id': 3016,
                    'number': 550,
                    'location': {
                        'id': 30,
                        'name': 'Stock 100'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                },
                'destinationTag': {
                    'location': {
                        'id': 27,
                        'name': 'Shipping'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                },
                'sourceTag': {
                    'id': 3016,
                    'number': 550,
                    'location': {
                        'id': 30,
                        'name': 'Stock 100'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                }
            },
            {
                'id': 549,
                'part': {
                    'id': 12,
                    'name': 'AC-01',
                    'description': 'Aluminum Casing'
                },
                'status': 'Entered',
                'type': 'Normal',
                'quantity': '4',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'slotNum': 2,
                'order': {
                    'id': 71,
                    'number': '10074',
                    'type': 'SO',
                    'itemId': 158
                },
                'note': '',
                'overPicked': false,
                'finishable': false,
                'destinationTag': {
                    'location': {
                        'id': 27,
                        'name': 'Shipping'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                },
                'sourceLocation': {
                    'location': {
                        'id': 30,
                        'name': 'Stock 100'
                    },
                    'locationGroup': {
                        'id': 5,
                        'name': 'SLC'
                    }
                }
            }
        ],
        'customFields': []
    }
};

export const pickAttributes: Attribute[] = [
    {
        name: 'id',
        type: 'integer',
        description: 'The pick\'s unique identification number.'
    },
    {
        name: 'number',
        type: 'string',
        description: 'The pick number. Usually the order type letter + order number (e.g., "SO12345"). Grouped picks use "G" + pick ID.'
    },
    {
        name: 'status',
        type: 'string',
        description: 'The pick status. Possible values: Entered, Started, Committed, Finished.'
    },
    {
        name: 'type',
        type: 'string',
        description: 'The pick type. Possible values: Pick, Putaway, Move.'
    },
    {
        name: 'priority',
        type: 'string',
        description: 'The pick priority. Possible values: 1-Highest, 2-High, 3-Normal, 4-Low, 5-Lowest.'
    },
    {
        name: 'locationGroup',
        type: 'reference object',
        description: 'The location group the pick is tied to.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the location group.',
            }
        ]
    },
    {
        name: 'username',
        type: 'string',
        description: 'The username of the user assigned to the pick.'
    },
    {
        name: 'dateCreated',
        type: 'date',
        description: 'Timestamp of when the pick was created.'
    },
    {
        name: 'dateScheduled',
        type: 'date',
        description: 'The scheduled date for the pick.'
    },
    {
        name: 'dateStarted',
        type: 'date',
        optional: true,
        description: 'Timestamp of when the pick was started. Null if not yet started.'
    },
    {
        name: 'dateFinished',
        type: 'date',
        optional: true,
        description: 'Timestamp of when the pick was finished. Null if not yet finished.'
    },
    {
        name: 'dateLastModified',
        type: 'date',
        description: 'Timestamp of when the pick was last modified.'
    },
    {
        name: 'toBePrinted',
        type: 'boolean',
        description: 'Whether the pick is flagged to be printed.'
    },
    {
        name: 'pickItems',
        type: 'list',
        description: 'A list of pick items. Each item represents a quantity of a part to be picked from a specific location.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The pick item\'s unique identification number.'
            },
            {
                name: 'part',
                type: 'reference object',
                description: 'The part to be picked.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The part number.',
                    },
                    {
                        name: 'description',
                        type: 'string',
                        description: 'The part description.',
                    }
                ]
            },
            {
                name: 'status',
                type: 'string',
                description: 'The pick item status. Possible values: Entered, Started, Committed, Finished, Short, Hold.'
            },
            {
                name: 'type',
                type: 'string',
                description: 'The pick item type. Possible values: Normal, BTO (Build-to-Order), PFL, None.'
            },
            {
                name: 'quantity',
                type: 'quantity',
                description: 'The quantity to pick.'
            },
            {
                name: 'uom',
                type: 'reference object with abbreviation',
                description: 'The unit of measure for the quantity.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the unit of measure.',
                    },
                    {
                        name: 'abbreviation',
                        type: 'string',
                        description: 'The abbreviated name.',
                    }
                ]
            },
            {
                name: 'slotNum',
                type: 'integer',
                description: 'The slot number on the pick cart for grouped picks.'
            },
            {
                name: 'order',
                type: 'object',
                description: 'The order this pick item is associated with.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The order\'s unique identification number.'
                    },
                    {
                        name: 'number',
                        type: 'string',
                        description: 'The order number.'
                    },
                    {
                        name: 'type',
                        type: 'string',
                        description: 'The order type. Possible values: SO, PO, TO, WO.'
                    },
                    {
                        name: 'itemId',
                        type: 'integer',
                        description: 'The ID of the specific order item (SO item, PO item, TO item, or WO item).'
                    }
                ]
            },
            {
                name: 'note',
                type: 'string',
                description: 'The note on the pick item (copied from the order item).'
            },
            {
                name: 'overPicked',
                type: 'boolean',
                description: 'Whether this pick item has been over-picked.'
            },
            {
                name: 'finishable',
                type: 'boolean',
                description: 'Whether this pick item can be finished (committed or non-inventory).'
            },
            {
                name: 'currentTag',
                type: 'object',
                optional: true,
                description: 'The tag where the pick item is currently located. This is the source tag when the pick item is initially created, and the destination tag once it is finished. Null if no tag has been assigned yet.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The tag\'s unique database ID.'
                    },
                    {
                        name: 'number',
                        type: 'integer',
                        description: 'The tag\'s human-readable number.'
                    },
                    {
                        name: 'location',
                        type: 'reference object',
                        description: 'The location where the tag is stored.',
                        children: [
                            {
                                name: 'id',
                                type: 'integer',
                                description: 'The unique identification number.',
                            },
                            {
                                name: 'name',
                                type: 'string',
                                description: 'The name of the location.',
                            }
                        ]
                    },
                    {
                        name: 'locationGroup',
                        type: 'reference object',
                        description: 'The location group the location belongs to.',
                        children: [
                            {
                                name: 'id',
                                type: 'integer',
                                description: 'The unique identification number.',
                            },
                            {
                                name: 'name',
                                type: 'string',
                                description: 'The name of the location group.',
                            }
                        ]
                    },
                ]
            },
            {
                name: 'destinationTag',
                type: 'object',
                optional: true,
                description: 'The destination location — where inventory will be moved TO when the pick is finished.',
                children: [
                    {
                        name: 'location',
                        type: 'reference object',
                        description: 'The destination location.',
                        children: [
                            {
                                name: 'id',
                                type: 'integer',
                                description: 'The unique identification number.',
                            },
                            {
                                name: 'name',
                                type: 'string',
                                description: 'The name of the location.',
                            }
                        ]
                    },
                    {
                        name: 'locationGroup',
                        type: 'reference object',
                        description: 'The location group the destination location belongs to.',
                        children: [
                            {
                                name: 'id',
                                type: 'integer',
                                description: 'The unique identification number.',
                            },
                            {
                                name: 'name',
                                type: 'string',
                                description: 'The name of the location group.',
                            }
                        ]
                    }
                ]
            },
            {
                name: 'sourceTag',
                type: 'object',
                optional: true,
                description: 'The pick item\'s initial source tag (where inventory was originally located).',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The source tag\'s unique database ID.'
                    },
                    {
                        name: 'number',
                        type: 'integer',
                        description: 'The source tag\'s human-readable number.'
                    },
                    {
                        name: 'location',
                        type: 'reference object',
                        optional: true,
                        description: 'The source location.',
                        children: [
                            {
                                name: 'id',
                                type: 'integer',
                                description: 'The unique identification number.',
                            },
                            {
                                name: 'name',
                                type: 'string',
                                description: 'The name of the location.',
                            }
                        ]
                    },
                    {
                        name: 'locationGroup',
                        type: 'reference object',
                        optional: true,
                        description: 'The location group the source location belongs to.',
                        children: [
                            {
                                name: 'id',
                                type: 'integer',
                                description: 'The unique identification number.',
                            },
                            {
                                name: 'name',
                                type: 'string',
                                description: 'The name of the location group.',
                            }
                        ]
                    }
                ]
            },
            {
                name: 'sourceLocation',
                type: 'object',
                optional: true,
                description: 'The pick item\'s initial source location. Present when there is no sourceTag but a source location still exists.',
                children: [
                    {
                        name: 'location',
                        type: 'reference object',
                        description: 'The source location.',
                        children: [
                            {
                                name: 'id',
                                type: 'integer',
                                description: 'The unique identification number.',
                            },
                            {
                                name: 'name',
                                type: 'string',
                                description: 'The name of the location.',
                            }
                        ]
                    },
                    {
                        name: 'locationGroup',
                        type: 'reference object',
                        description: 'The location group the source location belongs to.',
                        children: [
                            {
                                name: 'id',
                                type: 'integer',
                                description: 'The unique identification number.',
                            },
                            {
                                name: 'name',
                                type: 'string',
                                description: 'The name of the location group.',
                            }
                        ]
                    }
                ]
            },
            {
                name: 'tracking',
                type: 'object',
                optional: true,
                description: 'Part tracking information. Only present when the part has tracking enabled and tracking data exists.',
                children: [
                    {
                        name: 'trackingItems',
                        type: 'list',
                        description: 'List of tracking items.',
                        children: [
                            {
                                name: 'partTracking',
                                type: 'reference object',
                                description: 'The part tracking field definition.',
                                children: [
                                    {
                                        name: 'id',
                                        type: 'integer',
                                        description: 'The unique identification number.',
                                    },
                                    {
                                        name: 'name',
                                        type: 'string',
                                        description: 'The name of the tracking field.',
                                    },
                                    {
                                        name: 'description',
                                        type: 'string',
                                        optional: true,
                                        description: 'The description of the tracking field.',
                                    }
                                ]
                            },
                            {
                                name: 'value',
                                type: 'string',
                                optional: true,
                                description: 'The tracking value for non-serial number tracking types (e.g., Lot Number, Expiration Date). Dates are formatted as yyyy-MM-dd.'
                            },
                            {
                                name: 'serialNumbers',
                                type: 'list',
                                optional: true,
                                description: 'Serial numbers (only present for serial number tracking items).',
                                children: [
                                    {
                                        name: 'numbers',
                                        type: 'list',
                                        description: 'A list of serial number values.',
                                        children: [
                                            {
                                                name: 'partTracking',
                                                type: 'reference object',
                                                description: 'The part tracking field definition.'
                                            },
                                            {
                                                name: 'value',
                                                type: 'string',
                                                description: 'The serial number value.'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        name: 'customFields',
        type: 'list',
        description: 'A list of custom fields associated with the pick.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The custom field\'s unique identifier.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the custom field.',
            },
            {
                name: 'value',
                type: 'string',
                description: 'The custom field\'s value.'
            },
            {
                name: 'type',
                type: 'string',
                description: 'The category of the custom field\'s value.'
            },
        ]
    },
];
